export const KEYS = {
  PAGE_HAS_BEEN_VISITED: "PAGE_HAS_BEEN_VISITED",
  BOUNCE_RATE_POPUP_HAS_BEEN_CLOSED: "BOUNCE_RATE_POPUP_HAS_BEEN_CLOSED",
};
